import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router'; 
import { useSession } from '../Cart-Context/session';
import axios from 'axios';
import '../App.css';
import { API_BASE_URL } from '../utils/apiConfig.js';

const Checkout = () => {
    const { state } = useLocation(); 
    const navigate = useNavigate();
    const { sessionId, cartId } = useSession();
    const userRole = localStorage.getItem("userRole");

    const total = state?.total || 0.00; 
    const products = state?.products || []; 
    const experimentId = state?.experimentId || null; 
    
    const [status, setStatus] = useState('');

    const handleCompleteOrder = async () => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/checkout`, {
                sessionId,
                cartId,
                cartItems: products, 
                totalAmount: total,
                experimentId: experimentId 
            });
        
            if (response.status === 200) {
                sessionStorage.removeItem('cartId');
                sessionStorage.removeItem('experimentId');

                // Update the UI (like the cart badge)
                window.dispatchEvent(new Event("cartUpdated"));
        
                // Move to the final page where they copy their ID
                navigate('/order-complete'); 
            }
        } catch (err) {
            console.error("Checkout Error:", err);
            setStatus("Error processing order.");
        }
    };

    return (
        <main className="page-container">
            <div className="checkout-container">
                <h1 className="page-title">
                    {userRole === 'researcher' ? "Test Order Review" : "Review Your Order"}
                </h1>
                <div className="itemized-receipt">
                    {products.length > 0 ? (
                        products.map((p) => (
                            <div key={p.cartProductId} className="receipt-row">
                                <div className="receipt-item-info">
                                    <span className="receipt-item-name">{p.item.name}</span>
                                    <span className="receipt-item-qty">{p.quantity} x ${Number(p.item.price).toFixed(2)}</span>
                                </div>
                                <strong className="receipt-item-total">
                                    ${(p.item.price * p.quantity).toFixed(2)}
                                </strong>
                            </div>
                        ))
                    ) : (
                        <p>No items found in order.</p>
                    )}
                </div>

                <div className="checkout-total-banner">
                    <h2>Total: ${Number(total).toFixed(2)}</h2>
                </div>

                {status && <p className="error-msg">{status}</p>}

                <button 
                    onClick={handleCompleteOrder} 
                    className="complete-order-btn"
                    disabled={products.length === 0}
                >
                    {userRole === 'researcher' ? "Complete Test Order" : "Complete Order"}
                </button>
            </div>
        </main>
    );
};

export default Checkout;